import React, {Component} from "react";

import ContentLoader from "react-content-loader";
import DelayLink from "../../../helpers/delayLink";
import Ink from "react-ink";
import LazyLoad from "react-lazyload";

import {useLocation, useNavigate, useParams} from "react-router-dom";


import {connect} from "react-redux";
import {getDeliveryRestaurants, getSelfpickupRestaurants} from "../../../../services/restaurant/actions";
import CategorySlider from "../../../shared/CategorySlider";

class RestaurantList extends Component {
    state = {
        total: null,
        restaurants: [],
        loading: false,
        selfpickup: false,
        userPreferredSelectionDelivery: true,
        userPreferredSelectionSelfPickup: false,
        no_restaurants: false,
        data: [],
        review_data: [],
        isHomeDelivery: true,
    };

    componentDidMount() {
        if (localStorage.getItem("enSPU") === "true") {
            //when selfpickup is on
            if (localStorage.getItem("userPreferredSelection") === "DELIVERY") {
                this.setState({
                    selfpickup: false,
                    isHomeDelivery: true,
                    userPreferredSelectionDelivery: true,
                    userPreferredSelectionSelfPickup: false,
                });
                if (this.props.restaurants && this.props.restaurants.length <= 0) {
                    this.filterDelivery();
                }
            }
            if (
                localStorage.getItem("userPreferredSelection") === "SELFPICKUP" &&
                localStorage.getItem("enSPU") === "true"
            ) {
                this.setState({
                    selfpickup: true,
                    isHomeDelivery: false,
                    userPreferredSelectionSelfPickup: true,
                    userPreferredSelectionDelivery: false,
                });
                if (this.props.restaurants && this.props.restaurants.length <= 0) {
                    this.filterSelfPickup();
                }
            }
        } else {
            //when selfpickup is off by admin
            this.setState({
                selfpickup: false,
                isHomeDelivery: true,
                userPreferredSelectionDelivery: true,
                userPreferredSelectionSelfPickup: false,
            });
            if (this.props.restaurants && this.props.restaurants.length <= 0) {
                this.filterDelivery();
            }
        }

        if (localStorage.getItem("userPreferredSelection") === null) {
            localStorage.setItem("userPreferredSelection", "DELIVERY");
            localStorage.setItem("userSelected", "DELIVERY");
            this.setState({userPreferredSelectionDelivery: true, isHomeDelivery: true});
            this.__getDeliveryRestaurants();
        }

        if (this.props.restaurants && this.props.restaurants.length > 0) {
            this.setState({total: this.props.restaurants.length});
        }
    }

    __getDeliveryRestaurants = () => {
        if (localStorage.getItem("userSetAddress")) {
            this.setState({
                loading: true,
            });
            const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));

            this.props.getDeliveryRestaurants(userSetAddress.lat, userSetAddress.lng).then((restaurants) => {
                if (restaurants && restaurants.payload.length) {
                    this.setState({
                        total: restaurants.payload.length,
                        no_restaurants: false,
                        loading: false,
                    });
                } else {
                    this.setState({
                        total: null,
                        no_restaurants: true,
                    });
                }
            });
        }
    };

    __getSelfPickupRestaurants = () => {
        if (localStorage.getItem("userSetAddress")) {
            this.setState({
                loading: true,
            });
            const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));

            this.props.getSelfpickupRestaurants(userSetAddress.lat, userSetAddress.lng).then((restaurants) => {
                if (restaurants && restaurants.payload.length) {
                    this.setState({
                        total: restaurants.payload.length,
                        no_restaurants: false,
                        loading: false,
                    });
                } else {
                    this.setState({
                        total: null,
                        loading: false,
                        no_restaurants: true,
                    });
                }
            });
        }
    };

    filterDelivery = () => {
        this.setState(
            () => ({
                selfpickup: false,
                restaurants: [],
                userPreferredSelectionDelivery: true,
                userPreferredSelectionSelfPickup: false,
            }),
            () => {
                this.__getDeliveryRestaurants();
            }
        );
        localStorage.setItem("userPreferredSelection", "DELIVERY");
    };

    filterSelfPickup = () => {
        this.setState(
            () => ({
                selfpickup: true,
                restaurants: [],
                userPreferredSelectionSelfPickup: true,
                userPreferredSelectionDelivery: false,
            }),
            () => {
                this.__getSelfPickupRestaurants();
            }
        );
        localStorage.setItem("userPreferredSelection", "SELFPICKUP");
    };


    render() {
        return (
            <React.Fragment>
                <div className="mb-100">
                    <CategorySlider/>

                    {this.state.no_restaurants && (
                        <div
                            style={{
                                backgroundColor: "#f7fff3",
                                position: "sticky",
                                top: 0,
                                zIndex: 1000,
                                padding: "16px",
                                paddingTop: "30px",
                                marginTop: 10,
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                }}
                            >
                                {/* Message */}
                                <div
                                    style={{
                                        fontSize: "1rem",
                                        fontWeight: 500,
                                        color: "#6f6f6f",
                                        fontFamily: "'Inter', sans-serif",
                                    }}
                                >
                                    {localStorage.getItem("noRestaurantMessage")}
                                </div>

                                {/* Filters */}
                                <div style={{ display: "flex", gap: "8px" }}>
                                    <button
                                        onClick={this.filterDelivery}
                                        style={{
                                            padding: "6px 16px",
                                            borderRadius: "20px",
                                            border: "1px solid #5ba53e",
                                            backgroundColor: this.state.userPreferredSelectionDelivery
                                                ? "#5ba53e"
                                                : "#fff",
                                            color: this.state.userPreferredSelectionDelivery
                                                ? "#fff"
                                                : "#5ba53e",
                                            fontWeight: 500,
                                            fontSize: 13,
                                            fontFamily: "sans-serif",
                                            transition: "all 0.2s",
                                            outline: "none",
                                            WebkitTapHighlightColor: "transparent",
                                        }}
                                    >
                                        {localStorage.getItem("deliveryTypeDelivery")}
                                    </button>

                                    <button
                                        onClick={this.filterSelfPickup}
                                        style={{
                                            padding: "6px 16px",
                                            borderRadius: "20px",
                                            border: "1px solid #5ba53e",
                                            backgroundColor: this.state.userPreferredSelectionSelfPickup
                                                ? "#5ba53e"
                                                : "#fff",
                                            color: this.state.userPreferredSelectionSelfPickup
                                                ? "#fff"
                                                : "#5ba53e",
                                            fontWeight: 500,
                                            fontSize: 13,
                                            fontFamily: "sans-serif",
                                            transition: "all 0.2s",
                                            outline: "none",
                                            WebkitTapHighlightColor: "transparent",
                                        }}
                                    >
                                        {localStorage.getItem("deliveryTypeSelfPickup")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}


                    {this.state.total && (
                        <div
                            style={{
                                backgroundColor: "#f7fff3",
                                position: "sticky",
                                top: 0,
                                marginTop: 10,
                                zIndex: 1000,
                                padding: "12px 16px",
                                paddingTop: "30px"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                    gap: "8px",
                                }}
                            >

                                <div
                                    style={{
                                        margin: 0,
                                        paddingLeft: this.state.loading ? 2 : 0,
                                        fontSize: "1.1rem",
                                        fontWeight: 550,
                                        color: this.state.loading ? "#6f6f6f" : "#303030",
                                        fontFamily: "'Inter', sans-serif",
                                        textShadow: "0.5px 0.5px 0.5px rgba(0,0,0,0.01)",
                                    }}
                                >
                                    {this.state.loading
                                        ? "Loading..."
                                        : `${this.state.total} Stores Near You`}
                                </div>


                                <div style={{display: "flex", gap: "8px"}}>
                                    <button
                                        onClick={this.filterDelivery}
                                        style={{
                                            padding: "7px 15px",
                                            borderRadius: "20px",
                                            border: "1px solid #5ba53e",
                                            backgroundColor: this.state.userPreferredSelectionDelivery
                                                ? "#5ba53e" : "#fff",
                                            color: this.state.userPreferredSelectionDelivery ? "#fff" : "#5ba53e",
                                            fontWeight: 500,
                                            fontSize: 13,
                                            fontFamily: "sans-serif",
                                            transition: "all 0.2s",
                                            outline: "none",
                                            WebkitTapHighlightColor: "transparent",
                                        }}
                                    >
                                        Delivery
                                    </button>

                                    <button
                                        onClick={this.filterSelfPickup}
                                        style={{
                                            padding: "7px 15px",
                                            borderRadius: "20px",
                                            border: "1px solid #5ba53e",
                                            backgroundColor: this.state.userPreferredSelectionSelfPickup
                                                ? "#5ba53e" : "#fff",
                                            color: this.state.userPreferredSelectionSelfPickup ? "#fff" : "#5ba53e",
                                            fontWeight: 500,
                                            fontSize: 13,
                                            fontFamily: "sans-serif",
                                            transition: "all 0.2s",
                                            outline: "none",
                                            WebkitTapHighlightColor: "transparent",
                                        }}
                                    >
                                        Self Pickup
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}


                    {this.state.loading ? (
                        <ContentLoader
                            height={378}
                            width={400}
                            speed={1.2}
                            primaryColor="#f3f3f3"
                            secondaryColor="#ecebeb"
                        >
                            <rect x="20" y="20" rx="4" ry="4" width="80" height="78"/>
                            <rect x="144" y="30" rx="0" ry="0" width="115" height="18"/>
                            <rect x="144" y="60" rx="0" ry="0" width="165" height="16"/>

                            <rect x="20" y="145" rx="4" ry="4" width="80" height="78"/>
                            <rect x="144" y="155" rx="0" ry="0" width="115" height="18"/>
                            <rect x="144" y="185" rx="0" ry="0" width="165" height="16"/>

                            <rect x="20" y="270" rx="4" ry="4" width="80" height="78"/>
                            <rect x="144" y="280" rx="0" ry="0" width="115" height="18"/>
                            <rect x="144" y="310" rx="0" ry="0" width="165" height="16"/>
                        </ContentLoader>
                    ) : (
                        <React.Fragment>
                            {this.props.restaurants.length === 0 ? (
                                <ContentLoader
                                    height={378}
                                    width={400}
                                    speed={1.2}
                                    primaryColor="#f3f3f3"
                                    secondaryColor="#ecebeb"
                                >
                                    <rect x="20" y="20" rx="4" ry="4" width="80" height="78"/>
                                    <rect x="144" y="30" rx="0" ry="0" width="115" height="18"/>
                                    <rect x="144" y="60" rx="0" ry="0" width="165" height="16"/>
                                    <rect x="20" y="145" rx="4" ry="4" width="80" height="78"/>
                                    <rect x="144" y="155" rx="0" ry="0" width="115" height="18"/>
                                    <rect x="144" y="185" rx="0" ry="0" width="165" height="16"/>
                                    <rect x="20" y="270" rx="4" ry="4" width="80" height="78"/>
                                    <rect x="144" y="280" rx="0" ry="0" width="115" height="18"/>
                                    <rect x="144" y="310" rx="0" ry="0" width="165" height="16"/>
                                </ContentLoader>
                            ) : (
                                this.props.restaurants.map((restaurant) => (
                                    <React.Fragment key={restaurant.id}>
                                        <LazyLoad>
                                            <div className="col-xs-12 col-sm-12 restaurant-block">
                                                <DelayLink
                                                    to={`../stores/${restaurant.slug}`}
                                                    delay={200}
                                                    className="block text-center mb-3 single-store-homepage"
                                                    clickAction={() => {
                                                        localStorage.getItem("userPreferredSelection") === "DELIVERY" &&
                                                        restaurant.delivery_type === 1 &&
                                                        localStorage.setItem("userSelected", "DELIVERY");

                                                        localStorage.getItem("userPreferredSelection") === "SELFPICKUP" &&
                                                        restaurant.delivery_type === 2 &&
                                                        localStorage.setItem("userSelected", "SELFPICKUP");

                                                        localStorage.getItem("userPreferredSelection") === "DELIVERY" &&
                                                        restaurant.delivery_type === 3 &&
                                                        localStorage.setItem("userSelected", "DELIVERY");

                                                        localStorage.getItem("userPreferredSelection") === "SELFPICKUP" &&
                                                        restaurant.delivery_type === 3 &&
                                                        localStorage.setItem("userSelected", "SELFPICKUP");
                                                    }}
                                                >
                                                    <div
                                                        className={`block-content block-content-full ${
                                                            restaurant.is_featured && restaurant.is_active
                                                                ? "ribbon ribbon-bookmark ribbon-warning pt-2"
                                                                : "pt-2"
                                                        }`}
                                                    >
                                                        {/*{restaurant?.is_featured && (*/}
                                                        {/*    <div className="ribbon-box">*/}
                                                        {/*        {restaurant.custom_featured_name ?? localStorage.getItem("restaurantFeaturedText")}*/}
                                                        {/*    </div>*/}
                                                        {/*)}*/}

                                                        <div>
                                                            <img
                                                                src={`https://food.totalfresh.co${restaurant.image}`}
                                                                alt={restaurant.name}
                                                                className={`restaurant-image ${
                                                                    !restaurant.is_active && "restaurant-not-active"
                                                                }`}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="block-content block-content-full restaurant-info">
                                                        <div className="font-w600 mb-5 text-dark">
                                                            {restaurant.name}
                                                        </div>

                                                        <div className="font-size-sm text-muted truncate-text">
                                                            {restaurant.description}
                                                        </div>

                                                        {restaurant.custom_message_on_list &&
                                                            restaurant.custom_message_on_list !== "<p><br></p>" && (
                                                                <div
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: restaurant.custom_message_on_list,
                                                                    }}
                                                                />
                                                            )}

                                                        {!restaurant.is_active && (
                                                            <span className="restaurant-not-active-msg">
                    {localStorage.getItem("restaurantNotActiveMsg")}
                  </span>
                                                        )}

                                                        <hr className="my-10"/>

                                                        <div
                                                            className="text-center restaurant-meta mt-5 d-flex align-items-center justify-content-between text-muted">
                                                            <div className="col-2 p-0 text-left store-rating-block">
                                                                <i
                                                                    className={`fa fa-star pr-1 ${
                                                                        !restaurant.is_active && "restaurant-not-active"
                                                                    }`}
                                                                    style={{
                                                                        color: localStorage.getItem("storeColor"),
                                                                    }}
                                                                />
                                                                {restaurant.avgRating === "0"
                                                                    ? restaurant.rating
                                                                    : restaurant.avgRating}
                                                            </div>

                                                            {this.state.selfpickup ? (
                                                                <>
                                                                    <div
                                                                        className="col-4 p-0 text-center store-distance-block">
                                                                        <i className="si si-pointer pr-1"/>
                                                                        {restaurant.distance?.toFixed(1)} Km
                                                                    </div>

                                                                    <div
                                                                        className="col-6 p-0 text-center store-avgprice-block">
                                                                        <i className="si si-wallet"/>{" "}
                                                                        {localStorage.getItem("currencySymbolAlign") === "left"
                                                                            ? `${localStorage.getItem("currencyFormat")} ${restaurant.price_range}`
                                                                            : `${restaurant.price_range} ${localStorage.getItem("currencyFormat")}`}
                                                                        {localStorage.getItem("homePageForTwoText")}
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div
                                                                        className="col-3 p-0 text-center store-distance-block">
                                                                        <i className="si si-pointer pr-1"/>
                                                                        {restaurant.distance?.toFixed(1)} Km
                                                                    </div>

                                                                    <div
                                                                        className="col-3 p-0 text-center store-distance-block">
                                                                        <i className="si si-clock pr-1"/>
                                                                        {restaurant.delivery_time}{" "}
                                                                        {localStorage.getItem("homePageMinsText")}
                                                                    </div>

                                                                    <div
                                                                        className="col-4 p-0 text-center store-avgprice-block">
                                                                        <i className="si si-wallet"/>{" "}
                                                                        {localStorage.getItem("currencySymbolAlign") === "left"
                                                                            ? `${localStorage.getItem("currencyFormat")} ${restaurant.price_range}`
                                                                            : `${restaurant.price_range} ${localStorage.getItem("currencyFormat")}`}
                                                                        {localStorage.getItem("homePageForTwoText")}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <Ink duration="500" hasTouch={false}/>
                                                </DelayLink>
                                            </div>
                                        </LazyLoad>
                                    </React.Fragment>
                                ))
                            )}
                        </React.Fragment>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

// export default withRouter(RestaurantList);

const mapStateToProps = (state) => ({
    restaurants: state.restaurant.restaurants,
});

export function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let navigate = useNavigate();
        let params = useParams();
        let location = useLocation();
        return <Component {...props} router={{navigate, params, location}}/>;
    }

    return ComponentWithRouterProp;
}


export default withRouter(
    connect(
        mapStateToProps,
        {
            getDeliveryRestaurants,
            getSelfpickupRestaurants,
        }
    )(RestaurantList)
);
